import { render, staticRenderFns } from "./Expand-Slider-Module.vue?vue&type=template&id=0465fd05&"
import script from "./Expand-Slider-Module.vue?vue&type=script&lang=js&"
export * from "./Expand-Slider-Module.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports